// What each record section is called on the member's page. These are the member's words; the company configures the
// same sections under admin-facing names on the Loyalty settings page.
const SECTION_TITLES = {
  recommendations: 'Recommended for you',
  transactions: 'Your visits',
  appointments: 'Appointments',
  vehicles: 'Your vehicles',
  real_estate: 'Your properties',
  animals: 'Your pets',
  subscriptions: 'Your subscriptions',
};

export const RECORD_SECTIONS = Object.keys(SECTION_TITLES);

export default SECTION_TITLES;
